import React from 'react';

function ProgressBar({ progress }) {
  let classes = '';
  if (progress < 0) {
    classes = 'hidden';
  } else if (progress === 0) {
    classes = 'animate-appear';
  } else if (progress === 100) {
    classes = 'animate-disappear';
  }

  return (
    <div
      className={`${classes} flex flex-col items-center h-9 min-w-[70%] max-w-xl mt-4`}
    >
      <p className="text-base mb-1">Upload Progress</p>
      <div className="h-3 relative w-full rounded-full overflow-hidden">
        <div className="w-full h-full bg-neutral-200 absolute" />
        <div
          className={`${
            progress > 0 ? 'transition-all' : ''
          } h-full bg-primary-700 absolute`}
          style={{ width: `${progress}%` }}
        />
      </div>
    </div>
  );
}

export default ProgressBar;
